import { render } from "./CarteiraConsultor.vue?vue&type=template&id=3e150c62&scoped=true&ts=true"
import script from "./CarteiraConsultor.vue?vue&type=script&lang=ts"
export * from "./CarteiraConsultor.vue?vue&type=script&lang=ts"

import "./CarteiraConsultor.vue?vue&type=style&index=0&id=3e150c62&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e150c62"]])

export default __exports__